// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3TJNN","location":"Header_location__27z7b"};